<template>
  <div class="cancel-take">
    <ImmersionHeader
      ref="ImmersionHeader"
      :isShowBackBtn="true"
      :blackTheme="true"
      :title="$t('FoodC_pause_AtFL_nncW')"
      :titleStyle="titleStyle"
      @BackCK="BackCK"
    />
    <div v-if="!loading" :style="{ 'margin-top': headerHeight + 'px' }">
      <div class="pause_cc_box">
        <div v-if="!oldNoBuyPausedState" class="pause-wrap">
          <div class="text">
            {{ $t('FoodC_update_AxFi_uOud' /**暂停周期 */) }}
          </div>
          <div class="info">{{ pauseCycle }}</div>
        </div>
        <div class="pause-wrap">
          <div class="text">
            {{ $t('FoodC_update_UnpB_Dwqt' /**重新订阅时间 */) }}
          </div>
          <div class="info">
            {{ pauseResumeDate }}
          </div>
        </div>
        <div class="pause-wrap">
          <div class="text">
            {{ $t('FoodC_update_SekQ_qUvj' /**订阅费用 */) }}
          </div>
          <div class="info">
            {{ subscriptionPrice }}
          </div>
        </div>
        <div class="pause-wrap" @click="openJoinRules">
          <div class="text">
            {{ $t('FoodC_subscription_VPMP_seXT' /**Terms and Conditions */) }}
          </div>
          <div class="icon"></div>
        </div>
      </div>
      <!-- footer -->
      <memberFooter v-if="!oldNoBuyPausedState" :source="fromPageName" />
    </div>

    <LoadingMask v-else />
  </div>
</template>

<script>
/**
 * @desc 暂停订阅信息页（显示该页面逻辑：老客-未开通/已开通-暂停订阅）
 */
import { mapState } from 'vuex'
import LoadingMask from '@/components/loading/loading-mask.vue'
import ImmersionHeader from '@/components/immersionHeader/index.vue'
import { openJoinRules } from '@/page/member/common/utils.js'
import memberFooter from '@/page/member/components-v2/member-footer.vue'

export default {
  components: {
    LoadingMask,
    ImmersionHeader,
    memberFooter,
  },
  beforeRouteEnter(to, from = {}, next) {
    // 上层页面来源name：首页或管理页
    const fromPageName = from?.name
    next(vm => {
      vm.fromPageName = fromPageName
    })
  },
  data() {
    return {
      loading: false,
      headerHeight: 20,
      titleStyle: {
        color: '#000000',
        alpha: 1,
      },

      fromPageName: '', // 上层来源页面
    }
  },
  computed: {
    ...mapState(['membership']),
    pauseCycle() {
      return `${this.membership?.pauseStartDate}-${this.membership?.pauseEndDate}`
    },
    pauseResumeDate() {
      return this.membership?.pauseAutoResumeDate
    },
    subscriptionPrice() {
      return this.membership?.renewPriceSplit?.display
    },
    // 老客-未开通-暂停订阅
    oldNoBuyPausedState() {
      return this.membership?.status === 1 && this.membership?.subscriptionStatus === 3
    },
  },
  mounted() {
    try {
      const num = this.$refs?.ImmersionHeader?.$el?.offsetHeight || 0
      this.headerHeight = num + 20
    } catch (err) {}
  },
  methods: {
    BackCK() {
      window.history.go(-1)
    },
    openJoinRules,
  },
}
</script>

<style lang="scss" scoped>
.cancel-take {
  padding: 0 32px;
  background: #f5f5f7;
  height: 100%;
  overflow: hidden;
}
.payment-box {
  margin-bottom: 16px;
}
.title {
  font-family: DiDiSans-Pro-Bold;
  font-size: 36px;
  color: #000000;
  line-height: 43px;
  margin-bottom: 32px;
  padding-top: 48px;
}
.pause_cc_box {
  background-color: #fff;
  border-radius: 40px;
}
.pause-wrap {
  // background: #ffffff;
  // box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.04);
  // border-radius: 40px;
  display: flex;
  align-items: center;
  padding: 40px;
  justify-content: space-between;
  margin-bottom: 10px;
  .text {
    height: 40px;
    font-family: DiDiSans-Pro-Medium;
    font-size: 32px;
    color: #0b0b0d;
    line-height: 40px;
    font-weight: 500;
  }
  .info {
    font-family: DiDiSans-Pro-ExtraBold;
    font-size: 32px;
    color: #0b0b0d;
    text-align: right;
    line-height: 40px;
    font-weight: normal;
  }
  .icon {
    width: 36px;
    height: 36px;
    background-image: url('@/assets//images/member/right_arrow.png');
    background-size: 100% 100%;
  }
}
.pause-btn {
  margin-bottom: 24px;
}
.cancel-wrapper {
  .wrapper-text {
    opacity: 0.6;
    font-family: DiDiSans-Pro-Regular;
    font-size: 28px;
    color: #000000;
    line-height: 34px;
    padding-top: 40px;
    padding-bottom: 80px;
  }
  .rule-btn {
    .rich-btn {
      font-weight: normal;
    }
    .keep {
      text-align: center;
      font-family: DiDiSans-Pro-medium;
      font-size: 32px;
      line-height: 96px;
      height: 96px;
      color: #e08a5a;
    }
  }
}
</style>
